const contentUriTypeRegex = /^kf:([^:]+):(?:(.+):)?(.+)$/;

export function parseContentUri(contentUri: string): ContentUriParts {
  const match = contentUri?.match(contentUriTypeRegex);
  if (match == undefined)
    return {
      type: "none",
      location: "none",
      value: null,
    };
  return {
    type: match[1] as "tileset" | "file" | "cubeset",
    location: match[2] as "ion" | "self",
    value: match[3],
  };
}

type ContentUriParts = {
  type: "none" | "tileset" | "file" | "cubeset";
  location: "none" | "ion" | "self";
  value: string | null;
};
